import { motion } from 'framer-motion';

export const GingerAnimation = () => {
  return (
    <motion.div
      className="relative floating"
      whileHover={{ scale: 1.2, rotate: 10 }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      <motion.div
        className="text-9xl filter drop-shadow-lg"
        animate={{
          scale: [1, 1.2, 1],
          rotate: [0, 10, -10, 0],
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        🫚
      </motion.div>
      <motion.div
        className="absolute -top-4 -right-4 text-3xl"
        animate={{
          scale: [1, 1.5, 1],
          opacity: [0.5, 1, 0.5],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        ✨
      </motion.div>
      <motion.div
        className="absolute -bottom-4 -left-4 text-2xl"
        animate={{
          rotate: [0, 360],
          scale: [1, 1.3, 1],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "linear"
        }}
      >
        🔥
      </motion.div>
    </motion.div>
  );
};

export const GarlicAnimation = () => {
  return (
    <motion.div
      className="relative floating-delayed"
      whileHover={{ scale: 1.2, rotate: -10 }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      <motion.div
        className="text-9xl filter drop-shadow-lg"
        animate={{
          scale: [1, 1.15, 1],
          y: [0, -15, 0],
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        🧄
      </motion.div>
      <motion.div
        className="absolute -top-4 -right-4 text-3xl"
        animate={{
          opacity: [0, 1, 0],
          scale: [0.5, 1.5, 0.5],
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        �
      </motion.div>
      <motion.div
        className="absolute -bottom-4 -left-4 text-2xl"
        animate={{
          rotate: [0, -360],
          scale: [1, 1.2, 1],
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          ease: "linear"
        }}
      >
        💫
      </motion.div>
    </motion.div>
  );
};

export const PasteAnimation = () => {
  return (
    <motion.div
      className="relative"
      animate={{
        y: [0, -10, 0],
        rotate: [0, 5, -5, 0],
      }}
      transition={{
        duration: 6,
        repeat: Infinity,
        ease: "easeInOut"
      }}
      whileHover={{ scale: 1.1, rotate: 15 }}
    >
      <motion.div
        className="text-8xl filter drop-shadow-lg"
        animate={{
          scale: [1, 1.1, 1],
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        �
      </motion.div>
      <motion.div
        className="absolute -top-2 -right-2 text-2xl"
        animate={{
          opacity: [0.3, 1, 0.3],
          scale: [0.8, 1.2, 0.8],
        }}
        transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        ⭐
      </motion.div>
    </motion.div>
  );
};

export const BackgroundDecorations = () => {
  return (
    <>
      <motion.div
        className="absolute top-20 left-10 text-6xl opacity-20"
        animate={{
          rotate: [0, 360],
          scale: [1, 1.2, 1],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "linear"
        }}
      >
        🫚
      </motion.div>
      <motion.div
        className="absolute top-40 right-20 text-5xl opacity-20"
        animate={{
          rotate: [0, -360],
          scale: [1, 1.3, 1],
        }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: "linear"
        }}
      >
        🧄
      </motion.div>
      <motion.div
        className="absolute bottom-20 left-20 text-4xl opacity-20"
        animate={{
          y: [0, -20, 0],
          rotate: [0, 180],
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        🌿
      </motion.div>
      <motion.div
        className="absolute bottom-40 right-10 text-5xl opacity-20"
        animate={{
          y: [0, -15, 0],
          scale: [1, 1.2, 1],
        }}
        transition={{
          duration: 12,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        ⭐
      </motion.div>
    </>
  );
};
